export default __webpack_public_path__ + "static/logo-2-6684f61c11d0d6a894102fc9a701191e.png";